import {
  Activitysidebar,
  AnalyticsSidebar,
  Checklistsidebar,
  ClientFeedbackicon,
  Clientsidebar,
  Conferencesidebar,
  Contactsidebar,
  Deliverablesidebar,
  Developersettingsidebar,
  Emanagesettingsidebar,
  ESkillsSidebarIcon,
  HRsidebar,
  MintsMeetingsidebar,
  ProjectIdentification,
  Projectquerysidebar,
  Projectsidebar,
  ProjectTeamsize,
  ProjectTeamsizeBlack,
  ReportSidebar,
  ResourcePlannerIcon,
  RevittIcon,
  SidebarTimesheet,
  Subprojectsidebar,
  Tasksidebar,
  Variotionordrsidebar,
} from "../assets/svgicons";

export const menuData = [
  {
    label: "Production",
    children: [
      {
        label: "Projects",
        module: "projects",
        url: "/projects/onboarding",
        icon: <Projectsidebar width={18} height={18} />,
        checkUrl: "/projects",
      },
      {
        label: "Sub-Projects",
        module: "sub_projects",
        url: "/sub-projects/work-in-progress",
        icon: <Subprojectsidebar width={18} height={18} />,
        checkUrl: "/sub-projects",
      },
      {
        label: "Activity/Files",
        module: "activity_files",
        url: "/activity-files/not-started",
        icon: <Activitysidebar width={18} height={18} />,
        checkUrl: "/activity-files",
      },
      {
        label: "Deliverables",
        module: "deliverables",
        url: "/deliverables/overdue",
        icon: <Deliverablesidebar width={18} height={18} />,
        checkUrl: "/deliverables",
      },
      {
        label: "Project Queries",
        module: "pqs",
        url: "/project-queries",
        icon: <Projectquerysidebar width={18} height={18} />,
        checkUrl: "/project-queries",
      },
      {
        label: "Timesheet",
        module: "timesheets",
        url: "/timesheets",
        icon: <SidebarTimesheet width={18} height={18} />,
        checkUrl: "/timesheets",
      },
      {
        label: "Variation Orders",
        module: "vo",
        url: "/variation-orders",
        icon: <Variotionordrsidebar width={18} height={18} />,
        checkUrl: "/variation-orders",
      },
      {
        label: "Project Identification",
        module: "project-identification",
        url: "/project-identification/identification",
        icon: <ProjectIdentification width={18} height={18} />,
        checkUrl: "/project-identification",
      },
    ],
  },
  {
    label: "Settings",
    children: [
      {
        label: "Developer Settings",
        module: "developer_settings",
        url: "/developer-settings/modules",
        icon: <Developersettingsidebar width={18} height={18} />,
        checkUrl: "/developer-settings",
      },
      {
        label: "eManage Settings",
        module: "emanage_settings",
        url: "/emanage-settings/departments",
        icon: <Emanagesettingsidebar width={18} height={18} />,
        checkUrl: "/emanage-settings",
      },
    ],
  },
  {
    label: "Client",
    children: [
      {
        label: "Client Details",
        module: "clients",
        url: "/clients",
        icon: <Clientsidebar width={18} height={18} />,
        checkUrl: "/clients",
      },
      {
        label: "Contacts",
        module: "contacts",
        url: "/contacts",
        icon: <Contactsidebar width={18} height={18} />,
        checkUrl: "/contacts",
      },
      {
        label: "Checklist",
        module: "checklists",
        url: "/checklist",
        icon: <Checklistsidebar width={18} height={18} />,
        checkUrl: "/checklist",
      },
      {
        label: "Meeting Notes",
        module: "meeting_notes",
        url: "/meeting-notes/client",
        icon: <MintsMeetingsidebar width={18} height={18} />,
        checkUrl: "/meeting-notes",
      },
      {
        label: "Feedback",
        module: "client_feedback",
        url: "/feedback",
        icon: <ClientFeedbackicon width={18} height={18} />,
        checkUrl: "/feedback",
      },
      {
        label: "PRS",
        module: "prs",
        url: "/prs/live",
        icon: <ClientFeedbackicon width={18} height={18} />,
        checkUrl: "/prs",
      },
    ],
  },
  {
    label: "Resourcing",
    children: [
      //   {
      //     label: "Team Chart",
      //     module: "team_planner",
      //     url: "/",
      //     icon: <ProjectTeamsizeBlack width={18} height={18} />,
      //     checkUrl: "/",
      //   },
      {
        label: "Resource Planner",
        module: "resource_planner",
        url: "/resource-planner/activity",
        icon: <ResourcePlannerIcon width={18} height={18} />,
        checkUrl: "/resource-planner",
      },
      {
        label: "Team Chart",
        module: "team_planner",
        url: "/team-chart",
        icon: <ProjectTeamsizeBlack width={18} height={18} />,
        checkUrl: "/team-chart",
      },
      // {
      //   label: "Skill Matrix",
      //   module: "eskills",
      //   permission: "view_matrix",
      //   url: "/skills/skill-matrix",
      //   icon: <ESkillsSidebarIcon width={18} height={18} />,
      //   checkUrl: "/skills/skill-matrix",
      // },
      // {
      //   label: "Skill Planner",
      //   module: "eskills",
      //   permission: "view_planner",
      //   url: "/skills/skill-planner",
      //   icon: <ESkillsSidebarIcon width={18} height={18} />,
      //   checkUrl: "/skills/skill-planner",
      // },
    ],
  },
  {
    label: "Report",
    children: [
      {
        label: "Timesheet",
        module: "reports",
        url: "/reports/daily-timesheet-reports",
        permission: "view_reports",
        icon: <ReportSidebar width={18} height={18} />,
        checkUrl: "/reports",
      },
      // {
      //   label: "Skills Report",
      //   module: "reports",
      //   url: "/skill-reports/individual-skills-reports",
      //   permission: "view_reports",
      //   icon: <ESkillsSidebarIcon width={18} height={18} />,
      //   checkUrl: "/skill-reports",
      // },
      {
        label: "Analytics",
        module: "reports",
        url: "/analytical-reports",
        permission: "view_analytics",
        icon: <AnalyticsSidebar width={18} height={18} />,
        checkUrl: "/analytical-reports",
      },
      {
        label: "Revit",
        module: "reports",
        url: "/revit-reports",
        permission: "view_reports",
        icon: <RevittIcon width={18} height={18} />,
        checkUrl: "/revit-reports",
      },
    ],
  },
  {
    label: "General",
    children: [
      // {
      //   label: 'Conference',
      //   module: 'conference',
      //   url: '/conference/calender-view',
      //   icon: <Conferencesidebar width={18} height={18} />,
      //   checkUrl: '/conference',
      // },
      {
        label: "Task Reminder",
        module: "task_reminder",
        url: "/task-reminders/allTask",
        icon: <Tasksidebar width={18} height={18} />,
        checkUrl: "/task-reminders",
      },
      {
        label: "Trash",
        module: "trash",
        url: "/trash/projects",
        icon: <ReportSidebar width={18} height={18} />,
        checkUrl: "/trash",
      },
    ],
  },
];
